import { AccountAvatar, getInitials } from '@nexus/ari-lib';
import { Workspace } from '../hooks/use-workspaces';
import { workspaceAvatarColor } from '../lib/workspace-utils';

type WorkspaceAvatarProps = {
  workspace: Workspace;
  size?: number;
  fontSize?: number;
};

/**
 * Workspace identity mark: the organization logo when it has one, otherwise
 * initials on a name-derived colour so the active workspace is recognizable at
 * a glance. Squared off, so it never reads as a person the way the circular
 * account avatar does.
 */
export function WorkspaceAvatar({ workspace, size = 28, fontSize = 12 }: WorkspaceAvatarProps) {
  return (
    <AccountAvatar
      // no workspace logo for now, will use only the avatar color
      src={undefined}
      alt={workspace.shortName}
      sx={(theme) => ({
        width: size,
        height: size,
        fontSize,
        fontWeight: 700,
        flexShrink: 0,
        borderRadius: 1,
        color: theme.palette.common.white,
        bgcolor: workspaceAvatarColor(theme, workspace.shortName as string),
      })}
    >
      {getInitials(workspace.shortName as string, '')}
    </AccountAvatar>
  );
}
